export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4851.936ab127.jpg";